import { render, staticRenderFns } from "./member_grade.vue?vue&type=template&id=3647ceec&scoped=true"
import script from "./member_grade.vue?vue&type=script&lang=js"
export * from "./member_grade.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3647ceec",
  null
  
)

export default component.exports